<script lang="ts">
  import type { AnyCell, SheetProxy } from "@okcontract/cells";

  export let proxy: SheetProxy;
  export let value: AnyCell<unknown>;
  $: cell = proxy.get(value.id);
</script>

{$cell}
